import { gql } from '@apollo/client';
import { type DocumentNode } from 'graphql';

export const DELETE_TEMPLATE: DocumentNode = gql`
  mutation template($id: ID!) {
    deleteTemplate(id: $id)
  }
`;
